import { createLocalImage } from 'src/designSystem/LocalIcon';
import { cdnImage } from 'src/utils/cdn';

export const BoyAvatar = createLocalImage(cdnImage('avatars/boy.svg'));
export const GirlAvatar = createLocalImage(cdnImage('avatars/girl.svg'));
export const NeutralAvatar = createLocalImage(cdnImage('avatars/neutral.svg'));
export const CatAvatar = createLocalImage(cdnImage('avatars/cat.svg'));
export const DogAvatar = createLocalImage(cdnImage('avatars/dog.svg'));
export const UnicornAvatar = createLocalImage(cdnImage('avatars/unicorn.svg'));
